// @ts-ignore
import { extendMoment } from 'moment-range';
import Moment from 'moment-timezone';
import { QualaRange } from '../qualaRange';
import { IDate } from './types';

// @ts-ignore
export const moment = extendMoment(Moment);

/**
 *
 * organizes anything that responds to a provided getDate function and filters out points
 * that are outside the range
 *
 *
 * Note: that keys of objects need to be strings or number -- not Dates -- so I am using toString()
 *
 * We might want to consider getTime
 *
 * https://stackoverflow.com/questions/15861751/use-string-or-date-as-an-object-key-for-memoization
 * @param datedObjects something that resonds to date with a Date
 * @param range
 *
 * @returns { [key: string]: IMeasurement[] } all of the measurements for that date
 *
 */
export function organize<T extends IDate>(
  datedObjects: T[],
  range: QualaRange
): { [dateString: string]: T[] } {
  return (datedObjects || []).reduce((acc: { [dateString: string]: T[] }, datedObject: T) => {
    if (range.contains(datedObject.date)) {
      const dateString = moment(datedObject.date)
        .startOf(range.groupBy)
        .toDate()
        .toString();

      if (Object.prototype.hasOwnProperty.call(acc, dateString)) {
        acc[dateString].push(datedObject);
      } else {
        acc[dateString] = [datedObject];
      }
    }
    return acc;
  }, {});
}
